import React from "react";
var __jsx = React.createElement;
import { Fragment } from "react";
import stl from "./PostsContainer.module.css";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var PostsContainer = function PostsContainer(_ref) {
  var posts = _ref.posts;
  var thePostsFiltered = posts.filter(function (post) {
    return !post.isEligibilityCard;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.TP_container
  }, thePostsFiltered.map(function (post, idx) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: idx
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      rank: idx + 1
    })));
  })));
};
export default PostsContainer;